var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.65C13.225 16.65 16.65 13.225 16.65 9C16.65 4.77502 13.225 1.35 9 1.35C4.77502 1.35 1.35 4.77502 1.35 9C1.35 13.225 4.77502 16.65 9 16.65ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#1B1B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.925C9.37279 2.925 9.675 3.22721 9.675 3.6V9.17041L12.1773 11.6727C12.4409 11.9363 12.4409 12.3637 12.1773 12.6273C11.9137 12.8909 11.4863 12.8909 11.2227 12.6273L8.5227 9.9273C8.39612 9.80071 8.325 9.62902 8.325 9.45V3.6C8.325 3.22721 8.62721 2.925 9 2.925Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBlack);
export default __webpack_public_path__ + "static/media/clock-black.82a462e9d8824437e36049f8c8d4ea7a.svg";
export { ForwardRef as ReactComponent };